<template>
  <div class="cont">
    <div class="mytit" style="margin-bottom: 30px">
      <span
        style="cursor: default; float: left; margin-left: -15px; color: #0090ff"
        >事项公开</span
      >
      <a
        href="http://182.140.209.211:9003/hanyuanMap.html#/Disclosure"
        target="_blank"
        >更多&gt;&gt;</a
      >
    </div>
    <div class="sxgk-cont">
      <div class="left-tab">
        <div
          class="grfw"
          :class="{ activefw: showGR == true }"
          @click="changeTab('1')"
        >
          个人服务
        </div>
        <div
          class="frfw"
          :class="{ activefw: showGR == false }"
          @click="changeTab('2')"
        >
          法人服务
        </div>
      </div>
      <div class="pres" @click="pres()" title="上一个"><span title="上一页"></span>&lt;</div>
      <div class="nexts" title="下一个" @click="nexts()"><span></span>&gt;</div>
      <div class="right-cont">
        <div class="grfw-cont" v-show="showGR" id="grfw-cont">
          <div
            :style="setBgColor(item.name)"
            class="list-item"
            v-for="(item, index) in PersonalServiceList"
            :key="index"
          >
            <a class="list-item-title" @click="toLifeCycle(item.lifeCycleId, item.name,'1')">{{ item.name }}</a>
            <!-- <router-link
              class="list-item-title"
              target="_blank"
              :to="{
                path: 'LifeCycle',
                query: { lifeCycleId: item.lifeCycleId, name: item.name },
              }"
              >{{ item.name }}</router-link
            > -->
            <ul>
              <li v-for="(it, index) in item.matters" :key="index">
                <span class="li-circle"></span>
                <a style="color:#fff;cursor: pointer;" @click="toDetail(it.deptMatterId, it.name)">{{ it.name }}</a>
                <!-- <router-link
                  style="color: #fff"
                  target="_blank"
                  :to="{
                    path: 'ServiceGuide',
                    query: { matterId: it.matterId, name: it.name },
                  }"
                  >{{ it.name }}</router-link
                > -->
              </li>
            </ul>
          </div>
        </div>
        <div v-show="!showGR" class="frfw-cont" id="frfw-cont">
          <div
            :style="setBgColor(item.name)"
            class="list-item"
            v-for="(item, index) in CorporateServicesList"
            :key="index"
          >
            <a class="list-item-title" @click="toLifeCycle(item.lifeCycleId, item.name,'2')">{{ item.name }}</a>
            <!-- <router-link
              class="list-item-title"
              target="_blank"
              :to="{
                path: 'LifeCycle',
                query: { lifeCycleId: item.lifeCycleId, name: item.name },
              }"
              >{{ item.name }}</router-link
            > -->
            <ul>
              <li v-for="(it, index) in item.matters" :key="index">
                <span class="li-circle"></span>
                <!-- <a style="color:#fff;cursor: pointer;" @click="toDetail(it.matterId, it.name)">{{ it.name }}</a> -->
                <router-link
                  style="color: #fff"
                  target="_blank"
                  :to="{
                    path: 'ServiceGuide',
                    query: { deptMatterId: it.deptMatterId, name: it.name },
                  }"
                  >{{ it.name }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { lifeCycleMatter } from "@/api/map/index";
export default {
  name: "EnterDisclosure",

  data() {
    return {
      showGR: true, //个人法人切换
      PersonalServiceList: [], //个人服务列表
      CorporateServicesList: [], //法人服务列表
      itemImg: {
        //服务背景
        其他: require("../../assets/img/qita.png"),
        工作: require("../../assets/img/work.png"),
        升学: require("../../assets/img/shengxue.png"),
        购房: require("../../assets/img/goufang.png"),
        结婚: require("../../assets/img/jiehun.png"),
        生育: require("../../assets/img/shengyu.png"),
        失业: require("../../assets/img/shiye.png"),
        创业: require("../../assets/img/chuangye.png"),
        迁居: require("../../assets/img/qianju.png"),
        退休: require("../../assets/img/tuixiu.png"),
        后事: require("../../assets/img/houshi.png"),
        开办企业: require("../../assets/img/kbqy.png"),
        申请资质: require("../../assets/img/sqzz.png"),
        投资立项: require("../../assets/img/tzlx.png"),
        扩大生产: require("../../assets/img/kuodashengchan.png"),
        引进人才: require("../../assets/img/yinjinrencai.png"),
        办理社保: require("../../assets/img/banlishebao.png"),
        申请专利: require("../../assets/img/zhuanli.png"),
        缴纳税费: require("../../assets/img/shuifei.png"),
        申请贷款: require("../../assets/img/daikuan.png"),
        申请破产: require("../../assets/img/pochan.png"),
      },
      grfwsum: 0,
      frfwnum: 0,
    };
  },

  mounted() {
    this.getPersonalServices();
    this.scrollInit();
    this.scrollInits();
  },

  methods: {
    scrollInit() {
      const nav = document.getElementById("frfw-cont");
      nav.onwheel = function (event) {
        //禁止事件默认行为（此处禁止鼠标滚轮行为关联到"屏幕滚动条上下移动"行为）
        event.preventDefault();
        //设置鼠标滚轮滚动时屏幕滚动条的移动步长
        var step = 50;
        if (event.deltaY < 0) {
          //向上滚动鼠标滚轮，屏幕滚动条左移
          this.scrollLeft -= step;
        } else {
          //向下滚动鼠标滚轮，屏幕滚动条右移
          this.scrollLeft += step;
        }
      };
    },
    scrollInits() {
      const nav = document.getElementById("grfw-cont");
      nav.onwheel = function (event) {
        //禁止事件默认行为（此处禁止鼠标滚轮行为关联到"屏幕滚动条上下移动"行为）
        event.preventDefault();
        //设置鼠标滚轮滚动时屏幕滚动条的移动步长
        var step = 50;
        if (event.deltaY < 0) {
          //向上滚动鼠标滚轮，屏幕滚动条左移
          this.scrollLeft -= step;
        } else {
          //向下滚动鼠标滚轮，屏幕滚动条右移
          this.scrollLeft += step;
        }
      };
    },
    nexts() {
      if (this.showGR) {
        if (this.grfwsum >= 1900) {
          this.grfwsum = 0;
        } else {
          let num = document.getElementById("grfw-cont").scrollLeft;
          this.grfwsum = num + 200;
        }
        document.getElementById("grfw-cont").scroll({
          left: this.grfwsum,
          behavior: "smooth",
        });
      } else {
        if (this.frfwnum >= 1900) {
          this.frfwnum = 0;
        } else {
          let num = document.getElementById("frfw-cont").scrollLeft;
          this.frfwnum = num + 200;
        }
        document.getElementById("frfw-cont").scroll({
          left: this.frfwnum,
          behavior: "smooth",
        });
      }
    },
    pres() {
      if (this.showGR) {
        if (this.grfwsum >= 1900) {
          this.grfwsum = 0;
        } else {
          let num = document.getElementById("grfw-cont").scrollRight;
          this.grfwsum = num + 200;
        }
        document.getElementById("grfw-cont").scroll({
          left: this.grfwsum,
          behavior: "smooth",
        });
      } else {
        if (this.frfwnum >= 1900) {
          this.frfwnum = 0;
        } else {
          let num = document.getElementById("frfw-cont").scrollRight;
          this.frfwnum = num + 200;
        }
        document.getElementById("frfw-cont").scroll({
          left: this.frfwnum,
          behavior: "smooth",
        });
      }
    },
    // 获取个人服务列表
    getPersonalServices() {
      let params = {
        serviceTypeId: "1",
      };
      lifeCycleMatter(params).then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          this.PersonalServiceList = res.data.data;
          // console.log(res,this.PersonalServiceList,'@@')
          // 每个生命周期事项只展示4个，先删除多余事项
          for (
            let index = 0;
            index < this.PersonalServiceList.length;
            index++
          ) {
            if (this.PersonalServiceList[index].matters.length > 0) {
              this.PersonalServiceList[index].matters.splice(4);
            }
          }
          let obj = this.PersonalServiceList[0];
          this.PersonalServiceList.splice(0, 1);
          this.PersonalServiceList.push(obj);
        }
      });
    },
    // 获取法人服务列表
    getCorporateservices() {
      let params = {
        serviceTypeId: "2",
      };
      lifeCycleMatter(params).then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          this.CorporateServicesList = res.data.data;
          // 每个生命周期事项只展示4个，先删除多余事项
          for (
            let index = 0;
            index < this.CorporateServicesList.length;
            index++
          ) {
            if (this.CorporateServicesList[index].matters.length > 0) {
              this.CorporateServicesList[index].matters.splice(4);
            }
          }
          let obj = this.CorporateServicesList[0];
          this.CorporateServicesList.splice(0, 1);
          this.CorporateServicesList.push(obj);
        }
      });
    },
    // 个人法人切换
    changeTab(type) {
      if (type == "1") {
        this.showGR = true;
        this.getPersonalServices();
      } else {
        this.showGR = false;
        this.getCorporateservices();
      }
    },
    // 生命周期详情页
    toLifeCycle(id, name,type) {
      // this.$router.push({
      //   name: "LifeCycle",
      //   query: { lifeCycleId: id, name: name },
      // });
      let obj = { lifeCycleId: id, name: name, serviceTypeId: type };
      this.$router.push({
        name: "LifeCycle",
        params: { lifeCycleId: id, name: name, serviceTypeId: type }
      });
      sessionStorage.setItem('lifeCycleDetails',JSON.stringify(obj));
    },
    // 事项详情页
    toDetail(id, name) {
      // this.$router.push({
      //   name: "ServiceGuide",
      //   query: { matterId: id, name },
      // });
      let obj = { deptMatterId: id, name };
      this.$router.push({
        name: "ServiceGuide",
        params: { deptMatterId: id, name }
      });
      sessionStorage.setItem('matterDetails',JSON.stringify(obj));
    },
    // 设置每项生命周期背景颜色
    setBgColor(name) {
      switch (name) {
        case "其他":
          return { background: "url(" + this.itemImg["其他"] + ")" };
          break;
        case "工作":
          return { background: "url(" + this.itemImg["工作"] + ")" };
          break;
        case "开办企业":
          return { background: "url(" + this.itemImg["开办企业"] + ")" };
          break;
        case "投资立项":
          return { background: "url(" + this.itemImg["投资立项"] + ")" };
          break;
        case "申请资质":
          return { background: "url(" + this.itemImg["申请资质"] + ")" };
          break;
        case "升学":
          return { background: "url(" + this.itemImg["升学"] + ")" };
          break;
        case "购房":
          return { background: "url(" + this.itemImg["购房"] + ")" };
          break;
        case "结婚":
          return { background: "url(" + this.itemImg["结婚"] + ")" };
          break;
        case "生育":
          return { background: "url(" + this.itemImg["生育"] + ")" };
          break;
        case "失业":
          return { background: "url(" + this.itemImg["失业"] + ")" };
          break;
        case "创业":
          return { background: "url(" + this.itemImg["创业"] + ")" };
          break;
        case "迁居":
          return { background: "url(" + this.itemImg["迁居"] + ")" };
          break;
        case "退休":
          return { background: "url(" + this.itemImg["退休"] + ")" };
          break;
        case "后事":
          return { background: "url(" + this.itemImg["后事"] + ")" };
          break;
        case "扩大生产":
          return { background: "url(" + this.itemImg["扩大生产"] + ")" };
          break;
        case "引进人才":
          return { background: "url(" + this.itemImg["引进人才"] + ")" };
          break;
        case "办理社保":
          return { background: "url(" + this.itemImg["办理社保"] + ")" };
          break;
        case "申请专利":
          return { background: "url(" + this.itemImg["申请专利"] + ")" };
          break;
        case "缴纳税费":
          return { background: "url(" + this.itemImg["缴纳税费"] + ")" };
          break;
        case "申请贷款":
          return { background: "url(" + this.itemImg["申请贷款"] + ")" };
          break;
        case "申请破产":
          return { background: "url(" + this.itemImg["申请破产"] + ")" };
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.$emit("public_header", false);
    this.$emit("public_footer", false);
  },
};
</script>
<style scoped>
.cont {
  width: 1200px;
  margin: 0 auto;
}

.mytit {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 30px;
}

.mytit span {
  display: inline-block;
  font-weight: bold;
  font-size: 20px;
  line-height: 58px;
  height: 58px;
  padding: 0 18px;
}

span.on {
  color: #0090ff;
  float: left;
  margin-left: -15px;
}

.mytit > a {
  float: right;
  color: #9c9c9c;
  line-height: 64px;
  font-size: 14px;
}

.sxgk-cont {
  border: 1px solid #0090ff;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  border-left: none;
  position: relative;
}

.left-tab {
  width: 40px;
  height: 250px;
}

.grfw {
  padding: 10px;
  text-align: center;
  background-color: #e0f2fe;
  border: 1px solid #0090ff;
  border-top: none;
  cursor: pointer;
  height: 125px;
  box-sizing: border-box;
}

.frfw {
  padding: 10px;
  text-align: center;
  background-color: #e0f2fe;
  border: 1px solid #0090ff;
  border-top: none;
  border-bottom: none;
  cursor: pointer;
  height: 125px;
  box-sizing: border-box;
}

.activefw {
  background-color: #2aa6fe;
  color: #fff;
}

.right-cont {
  width: 93%;
}

.grfw-cont,
.frfw-cont {
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 1115px;
  overflow: hidden;
  overflow-x: scroll;
  margin-left: 25px;
}
.grfw-cont::-webkit-scrollbar {
  display: none;
}
.frfw-cont::-webkit-scrollbar {
  display: none;
}

.list-item {
  background-size: 100%;
  width: 250px;
  height: 210px;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 20px 10px 0;
}

.list-item .list-item-title,
.list-item ul > li {
  margin: 15px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
}

.list-item .list-item-title {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.li-circle {
  width: 6px;
  height: 6px;
  background-color: #fff;
  display: inline-block;
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: 3px;
}

.sx-item {
  background-color: #60c9fe;
  padding: 20px;
  color: #fff;
}

.sx-item p {
  font-size: 18px;
  cursor: pointer;
  text-align: left;
}

.sx-item ul li {
  list-style: disc;
  margin: 5px;
  cursor: pointer;
  text-align: left;
}
.nexts {
  position: absolute;
  display: block;
  right: 2px;
  font-size: 26px;
  color: #9c9c9c;
  cursor: pointer;
}
.pres{
  position: absolute;
  display: block;
  left: 44px;
  font-size: 26px;
  color: #9c9c9c;
  cursor: pointer;
}
</style>